var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{class:_vm.slotsClass},_vm._l((_vm.slotDates),function(slot,index){return _c('li',{key:index,staticClass:"slots__slot"},[_c('common-time',{attrs:{"date":slot.from}}),(slot.to)?[_vm._v(" "+_vm._s(_vm.$t('common.microcopy.to'))+" "),_c('common-time',{attrs:{"date":slot.to}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }